<template>
  <div>
      <div class="wrap" v-if="isMobile">
          <div class="mbanner">
            <h2>什么是游戏代练师？</h2>
                <p>游戏代练师是根据《游戏代练师》团体标准，由中国工业合作协会与“代练通”共同组织并实施的职业技能认定项目。</p>
                <p>《游戏代练师》职业技能标准的发布与实施，为游戏代练行业中客观存在的大量代练人员提供了行业性的官方认可和职业技能考评依据，从而让游戏代练行业及相关持证人员获得更广泛的社会认可。</p>

            <p><router-link  to="/sign-up" >立即报名</router-link></p>
        </div>

        <div class="clear"></div>

        <div class="mprocedure">
            <h2>游戏代练师流程</h2>
            <div class="mprocedure-circle">
                <!--  //0:无     1：实名认证    2：在线报名   3：理论考试      4：实操考试        5：证书办理  -->
                <template v-if="isShow">
                    <dl>
                        <template v-if="processId==0">
                            <!--  待完成  -->
                            <dd>
                                <router-link :to="'/sign-up'" class="no-complete"><i class="second2"></i>在线报名<b class="orange">待完成</b></router-link>
                            </dd>
                            <dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId>=1">
                            <!--  已完成  -->
                            <dd>
                                <router-link :to="'/sign-up'" ><i class="second"></i>在线报名<b>完成</b></router-link>
                            </dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId==0">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="second1"></i>实名认证</a></dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId==1">
                            <!--  待完成  -->
                            <dd> <router-link :to="'/auth'" class="no-complete"><i class="first2"></i>实名认证<b class="orange">待完成</b></router-link></dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId>1">
                             <!--  已完成  -->
                            <dd> <router-link :to="'/auth'"><i class="first"></i>实名认证<b>完成</b></router-link></dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=1">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="third1"></i>理论考试</a></dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId==2">
                            <!--  待完成  -->
                           <dd>
                            <router-link to="/exam-result" class="no-complete"><i class="third2"></i>理论考试<b class="orange">待完成</b></router-link>
                           </dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId>2">
                            <!--  已完成  -->
                            <dd>
                              <router-link to="/exam-result" ><i class="third"></i>理论考试<b>完成</b></router-link>
                            </dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=2">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="fourth1"></i>实操考试</a></dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId==3">
                           <!--  待完成  -->
                           <dd>
                            <router-link to="/operation" class="no-complete"><i class="fourth2"></i>实操考试<b class="orange">待完成</b></router-link></dd><dt><em class="el-icon-caret-right gray"></em></dt>
                        </template>
                        <template v-else-if="processId>3">
                            <!--  已完成  -->
                           <dd><router-link to="/operation" ><i class="fourth"></i>实操考试<b>完成</b></router-link></dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=3">
                            <!--  灰的不可编辑  -->
                           <dd><a href="#" class="unable"><i class="fifth1"></i>证书办理</a></dd><dt></dt>
                        </template>
                        <template v-else-if="processId==4">
                           <!--  待完成  -->
                          <dd><router-link to="/address" class="no-complete"><i class="fifth2"></i>证书办理<b class="orange">待完成</b></router-link>

                          </dd><dt></dt>
                        </template>
                        <template v-else-if="processId>4">
                            <!--  已完成  -->
                          <dd><router-link to="/address" ><i class="fifth"></i>证书办理<b>完成</b></router-link>
                          </dd><dt></dt>
                        </template>
                    </dl>
                </template>
                <template v-else>
                <dl>
                    <dd>
                        <router-link to="/login" ><i class="second"></i>在线报名</router-link></dd><dt><em class="el-icon-caret-right"></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="first"></i>实名认证</router-link>
                    </dd><dt><em class="el-icon-caret-right"></em></dt>
                </dl>

                <dl>
                    <dd><router-link to="/login" ><i class="third"></i>理论考试</router-link></dd><dt><em class="el-icon-caret-right"></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="fourth"></i>实操考试</router-link>
                        </dd><dt><em class="el-icon-caret-right"></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="fifth"></i>证书办理</router-link>
                    </dd><dt></dt>
                </dl>

                </template>
            </div>
	    </div>

        <div class="mnews">
            <h2>公示公告<i class="triangle-right triangle-right-black mgt16-m fr"></i><router-link to="/notice" ><span>更多</span></router-link></h2>
            <ul>
                 <li v-for="item in noticeArr" v-bind:key="item.ID" >
                    <router-link :to="'/details/'+item.ID" >{{item.Title}}</router-link>
                    <span>{{formatDate(item.CreateDate)}}</span>
                </li>
            </ul>
        </div>

        <div class="mnews">
            <h2>资讯<i class="triangle-right triangle-right-black mgt16-m fr"></i><router-link to="/information" ><span>更多</span></router-link></h2>
            <ul>
                <li v-for="item in informationArr" v-bind:key="item.ID" >
                    <router-link :to="'/details/'+item.ID" >{{item.Title}}</router-link>
                    <span>{{formatDate(item.CreateDate)}}</span>
                </li>
            </ul>
        </div>

      </div>
      <div v-else>
          <div class="banner">
            <div class="content">
                <h2>什么是游戏代练师？</h2>
                <p>游戏代练师是根据《游戏代练师》团体标准，由中国工业合作协会与“代练通”共同组织并实施的职业技能认定项目。</p>
                <p>《游戏代练师》职业技能标准的发布与实施，为游戏代练行业中客观存在的大量代练人员提供了行业性的官方认可和职业技能考评依据，从而让游戏代练行业及相关持证人员获得更广泛的社会认可。</p>
                <p><router-link  to="/sign-up" >立即报名</router-link></p>
            </div>
        </div>

        <div class="clear"></div>

        <div class="procedure content">
            <h2>游戏代练师流程</h2>
            <div>
                <!--  //0:无     1：实名认证    2：在线报名   3：理论考试      4：实操考试        5：证书办理  -->
                <template v-if="isShow">
                    <dl>
                        <template v-if="processId==0">
                            <!--  待完成  -->
                            <dd>
                                <router-link :to="'/sign-up'" class="no-complete"><i class="second2"></i>在线报名<b class="orange">待完成</b></router-link>
                            </dd>
                            <dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId>=1">
                            <!--  已完成  -->
                            <dd>
                                <router-link :to="'/sign-up'" ><i class="second"></i>在线报名<b>完成</b></router-link>
                            </dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId==0">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="second1"></i>实名认证<span class="triangle-right triangle-right-gray"></span></a></dd><dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId==1">
                            <!--  待完成  -->
                            <dd> <router-link :to="'/auth'" class="no-complete"><i class="first2"></i>实名认证<b class="orange">待完成</b></router-link></dd><dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId>1">
                             <!--  已完成  -->
                            <dd> <router-link :to="'/auth'"><i class="first"></i>实名认证<b>完成</b></router-link></dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=1">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="third1"></i>理论考试<span class="triangle-right triangle-right-gray"></span></a></dd><dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId==2">
                            <!--  待完成  -->
                           <dd>
                            <router-link to="/exam-result" class="no-complete"><i class="third2"></i>理论考试<b class="orange">待完成</b></router-link>
                           </dd><dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId>2">
                            <!--  已完成  -->
                            <dd>
                              <router-link to="/exam-result" ><i class="third"></i>理论考试<b>完成</b></router-link>
                            </dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=2">
                            <!--  灰的不可编辑  -->
                            <dd><a href="#" class="unable"><i class="fourth1"></i>实操考试<span class="triangle-right triangle-right-gray"></span></a></dd><dt><em class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId==3">
                           <!--  待完成  -->
                           <dd>
                            <router-link to="/operation" class="no-complete"><i class="fourth2"></i>实操考试<b class="orange">待完成</b></router-link></dd><dt><em  class="gray"></em></dt>
                        </template>
                        <template v-else-if="processId>3">
                            <!--  已完成  -->
                           <dd><router-link to="/operation" ><i class="fourth"></i>实操考试<b>完成</b></router-link></dd><dt><em></em></dt>
                        </template>
                    </dl>

                    <dl>
                        <template v-if="processId<=3">
                            <!--  灰的不可编辑  -->
                           <dd><a href="#" class="unable"><i class="fifth1"></i>证书办理<span class="triangle-right triangle-right-gray"></span></a></dd><dt></dt>
                        </template>
                        <template v-else-if="processId==4">
                           <!--  待完成  -->
                          <dd><router-link to="/address" class="no-complete"><i class="fifth2"></i>证书办理<b class="orange">待完成</b></router-link>

                          </dd><dt></dt>
                        </template>
                        <template v-else-if="processId>4">
                            <!--  已完成  -->
                          <dd><router-link to="/address" ><i class="fifth"></i>证书办理<b>完成</b></router-link>
                          </dd><dt></dt>
                        </template>
                    </dl>
                </template>
                <template v-else>
                <dl>
                    <dd>
                        <router-link to="/login" ><i class="second"></i>在线报名<span class="triangle-right triangle-right-blue"></span></router-link></dd><dt><em></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="first"></i>实名认证<span class="triangle-right triangle-right-blue"></span></router-link>
                    </dd><dt><em></em></dt>
                </dl>

                <dl>
                    <dd><router-link to="/login" ><i class="third"></i>理论考试<span class="triangle-right triangle-right-blue"></span></router-link></dd><dt><em></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="fourth"></i>实操考试<span class="triangle-right triangle-right-blue"></span></router-link>
                        </dd><dt><em></em></dt>
                </dl>

                <dl>
                    <dd>
                        <router-link to="/login" ><i class="fifth"></i>证书办理<span class="triangle-right triangle-right-blue"></span></router-link>
                    </dd><dt></dt>
                </dl>

                </template>
            </div>
	    </div>

        <div class="content">
            <div class="news news1">
            <h2>公示公告<i class="triangle-right triangle-right-black mgt16 fr"></i><router-link to="/notice" ><span>更多</span></router-link></h2>
            <ul>
                 <li v-for="item in noticeArr" v-bind:key="item.ID" >
                    <router-link :to="'/details/'+item.ID" >{{item.Title}}</router-link>
                    <span>{{formatDate(item.CreateDate)}}</span>
                </li>
            </ul>
            </div>

            <div class="news news2 ">
            <h2>资讯<i class="triangle-right triangle-right-black mgt16 fr"></i><router-link to="/information" ><span>更多</span></router-link></h2>
            <ul>
                <li v-for="item in informationArr" v-bind:key="item.ID" >
                    <router-link :to="'/details/'+item.ID" >{{item.Title}}</router-link>
                    <span>{{formatDate(item.CreateDate)}}</span>
                </li>
            </ul>
        </div>
        </div>
      </div>


  </div>
</template>

<style scoped>
.price{background: #fff;}
.price h2{ text-align: center; color:#000000; font-weight: normal; padding-bottom:20px; padding-top:20px;}
.price li{ float: left; width:33%; text-align: center;}
.price span{ display: block; font-size:12px;padding-bottom:10px;}
.price i{ font-style: normal; color:#66b1ff; font-size:18px;padding-bottom:10px;display: block;}
.price em{ display: block;font-size:18px;padding-bottom:10px;}
.price p{font-size:13px; padding:20px 20%;}

.banner{background:url('../assets/banner.png') no-repeat top center; width:100%; height:308px; }
.banner h2{ color:#fff; font-weight:normal;font-size: 32px; margin-top: 32px; margin-bottom: 16px;}
.banner p{width: 660px;height: 56px;font-size: 16px; color: #fff;line-height: 28px;margin-bottom: 8px;}
.banner a{ display:block; width:110px; height:40px; line-height:40px; background:#ffdd57;color: #2a2a2a;  margin-top:36px;  border-radius: 2px;text-align: center; }

.procedure{ height:216px; background:#fff; margin-top:24px; margin-bottom:24px; }
.procedure h2{font-size: 20px;color: #2a2a2a;margin-top: 24px;margin-bottom: 32px;padding-left:40px;}
.procedure dl{ padding-left:40px;}
.procedure dd{ float:left;text-align:center; width:110px;}
.procedure dt{ float:left; }
.procedure i{ width:64px; height:64px; display:block;background:url('../assets/icon2.jpg') no-repeat; margin-left:23px;margin-bottom:15px; }
.procedure i.second{ background-position-y:-64px;}
.procedure i.third{ background-position-y:-128px;}
.procedure i.fourth{ background-position-y:-192px;}
.procedure i.fifth{ background-position-y:-256px;}

.procedure i.first1{background-position-x:-64px;}
.procedure i.first2{background-position-x:-128px;}

.procedure i.second1{background-position-y:-64px;background-position-x:-64px;}
.procedure i.second2{background-position-y:-64px;background-position-x:-128px;}

.procedure i.third1{ background-position-y:-128px;background-position-x:-64px;}
.procedure i.third2{ background-position-y:-128px;background-position-x:-128px;}

.procedure i.fourth1{ background-position-y:-192px;background-position-x:-64px;}
.procedure i.fourth2{ background-position-y:-192px;background-position-x:-128px;}

.procedure i.fifth1{ background-position-y:-256px;background-position-x:-64px;}
.procedure i.fifth2{ background-position-y:-256px;background-position-x:-128px;}

.procedure em{border-bottom: 1px dashed #1890ff;margin-top:32px;width:84px;height: 1px;display:inline-block;}
.procedure em.gray{border-bottom-color: #d4d4d4;}
.procedure a{ color: #1890ff;font-size: 14px;  display:block;}
.procedure a.no-complete{color:#ffa200;}
.procedure a.unable{color:#d4d4d4;}
.procedure b{background:#1890ff;border-radius: 1px;color: #fff; font-weight: normal; margin-left: 4px;font-size: 10px;padding: 1px 6px;}
.procedure b.orange{background:#ffa200;}

.news{ background:#fff;  height:328px; float:left; margin-bottom:48px;}
.news1{width:386px;}
.news2{width:550px; margin-left:24px;}
.news h2{font-size: 14px;color:#2a2a2a;padding:0 16px; height:40px; line-height:40px; border-bottom:1px solid #f2f2f2;}
.news h2 span{font-size: 14px;color:#747474;cursor: pointer; float:right; font-weight:normal;}
.news ul{ margin-top:10px;overflow: hidden;}
.news li{cursor: pointer; margin-top: 12px; height: 20px;line-height: 20px;display:flex;}
.news li span{overflow: hidden; color: #aaa;  text-align:right; margin-right:16px; width:25%;font-size:14px; }
.news a{width:75%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;color: #747474; margin-left: 16px; font-size:14px; }
.news a:hover{color:#1890ff;}


.mbanner{background:#026bcd url('../assets/mbanner.png') no-repeat right bottom; width:100%;  background-size: 100%; padding-bottom:1rem;  }
.mbanner h2{ color:#fff; font-weight:normal;font-size:1.4rem; margin-bottom:1.2rem; padding-top:1.2rem; padding-left:5%;}
.mbanner p{font-size:1.2rem; color: #fefefe;margin-bottom:0.4rem;padding:0 5%; width:90%;}
.mbanner a{ display: inline-block; padding:1rem 2rem; font-weight: bold;  background:#ffdd57;color: #2a2a2a;  margin-top:1.8rem;   border-radius: 2px;text-align: center; font-size:1.4rem; }

.mprocedure{  background:#fff; margin-top:1.2rem; margin-bottom:1.2rem; padding-bottom:2rem; overflow: hidden; }
.mprocedure h2{font-size: 1.4rem;color: #2a2a2a;margin-top:1.2rem;margin-bottom:1.6rem;padding-left:2rem;}
.mprocedure dl{  float: left; width:20%;}
.mprocedure dd{ float:left;text-align:center; width:80%;}
.mprocedure dt{ float:left; width:20%; }
.mprocedure-circle{ width:96%; padding-left:4%;}

.mprocedure i{ width:50px; height:50px; display:block;background:url('../assets/icon22.jpg') no-repeat; margin:0 auto 1rem;   }
.mprocedure i.second{ background-position-y:-50px;}
.mprocedure i.third{ background-position-y:-100px;}
.mprocedure i.fourth{ background-position-y:-150px;}
.mprocedure i.fifth{ background-position-y:-200px;}
.mprocedure i.first1{background-position-x:-50px;}
.mprocedure i.first2{background-position-x:-100px;}
.mprocedure i.second1{background-position-y:-50px;background-position-x:-50px;}
.mprocedure i.second2{background-position-y:-50px;background-position-x:-100px;}
.mprocedure i.third1{ background-position-y:-100px;background-position-x:-50px;}
.mprocedure i.third2{ background-position-y:-100px;background-position-x:-100px;}
.mprocedure i.fourth1{ background-position-y:-150px;background-position-x:-50px;}
.mprocedure i.fourth2{ background-position-y:-150px;background-position-x:-100px;}
.mprocedure i.fifth1{ background-position-y:-200px;background-position-x:-50px;}
.mprocedure i.fifth2{ background-position-y:-200px;background-position-x:-100px;}

.mprocedure em{margin-top:1.6rem;display:inline-block; margin-right:2%;}
.mprocedure em.gray{color: #d4d4d4;}

.mprocedure a{ color: #1890ff;font-size:1.2rem;  display:block;}
.mprocedure a.no-complete{color:#ffa200;}
.mprocedure a.unable{color:#d4d4d4;}
.mprocedure b{font-size:1rem; background:#1890ff;border-radius:0.2rem;color: #fff; font-weight: normal; width:70%; text-align: center; padding:0.2rem 0.3rem; display: block; margin:0.5rem auto 0;}
.mprocedure b.orange{background:#ffa200;}

.mnews{ background:#fff;  float:left; margin-bottom:2.4rem;padding:0 4%; width:92%;}
.mnews h2{font-size:1.2rem;color:#2a2a2a;height:3rem; line-height:3rem; border-bottom:1px solid #f2f2f2;}
.mnews h2 span{font-size:1.2rem;color:#747474;cursor: pointer; float:right; font-weight:normal;}
.mnews ul{ overflow: hidden; margin-bottom:2rem;}
.mnews li{cursor: pointer; margin-top:1rem; height:1.4rem;line-height:1.4rem;display:flex; width:100%;}
.mnews li span{overflow: hidden; color: #aaa;   font-size:1.2rem;  display:block; width:35%; text-align: right; }
.mnews a{width:65%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;color: #747474;  font-size:1.2rem; }
.mnews a:hover{color:#1890ff;}
</style>

<script>

  export default {
    name: 'home',
    methods: {
       index(){
            const self = this;
            var data= self.common.GetlocalStorage("UnLockUserData");
            var userId=0;
            if(data)

                userId=JSON.parse(data).UserID;
                self.http.ajaxGet("Index?UserID="+userId,function(res){
                if(res.ReturnCode == 1){
                    self.processId=res.Message;
                    self.noticeArr=res.Result;
                    self.informationArr=res.Result1;
                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
        },
        formatDate(date){
            return this.http.dateFormat1("yyyy-MM-dd",date);
        },
        closeWindow(val){
				this.isShowWindow=val;
        },
        pay(index){
            const self = this;
            var data= self.common.GetlocalStorage("UnLockUserData");
            var userId=0;
            if(data){
                if(index==1){
                    this.bal=200;
                }else if(index==2){
                    this.bal=400;
                }else if(index==3){
                    this.bal=600;
                }

                this.isShowWindow=true;
            }else{
                self.$router.push({name: "login"});
            }
        },
        qudao(){
            //获取链接地址的渠道信息
            var data= this.common.GetQueryString("qudao");
            if(data){
                var obj={"qudao":data,"startTime":new Date()};
                this.common.SetlocalStorage(JSON.stringify(obj),"qudao");
            }
        }
    },
    data() {
      return {
        processId:0,                //0:无     1：实名认证    2：在线报名   3：理论考试      4：实操考试        5：证书办理
        noticeArr:[],               //公告
        informationArr:[],           //资讯

        IsMySignUpPage:false,
        isShowWindow:false,
        bal:0,
        id:10
      }
	},
	mounted: function () {
        this.index();
        this.qudao();
    },
  computed:{
    isShow(){
       return this.$store.getters.isShow;
    },
    nickName(){
       return this.$store.getters.nickName;
    },
    isMobile(){
       return this.common.isMobile();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home.vue